<template>
  <div class="actor-detail-knowledge-base">
    <h2 class="h2" v-if="showTitle">
      {{ knowledgeBaseLabel }}
      <div class="title-count">{{ posts.length }}</div>
    </h2>

    <div v-if="loading" class="tw-flex items-center justify-center py-8 text-gray-500">
      <Icon name="spinner" class="w-5 h-5 animate-spin inline-block mr-2"/>
      {{ $t('knowledge_base_searching') }}
    </div>

    <div
      v-else-if="posts.length > 0"
      class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4"
    >
      <KnowledgeBasePostCard
        v-for="post in posts"
        :key="post.id"
        :post="post"
      />
    </div>

    <p v-else class="text-sm text-gray-400 py-4">
      {{ $t('knowledge_base_no_results') }}
    </p>
  </div>
</template>

<script lang="ts">
  import { defineComponent } from 'vue'
  import Icon from '@/components/Icon/Icon.vue'
  import KnowledgeBasePostCard from '@/Domain/KnowledgeBase/Components/KnowledgeBasePostCard.vue'
  import TranslationsMixin from '@/util/TranslationsMixin'

  export default defineComponent({
    name: 'ActorDetailKnowledgeBasePosts',
    mixins: [TranslationsMixin],
    components: {
      Icon,
      KnowledgeBasePostCard,
    },
    props: {
      posts: {
        type: Array,
        default: () => [],
      },
      loading: {
        type: Boolean,
        default: false,
      },
      showTitle: {
        type: Boolean,
        default: true,
      },
    },
  })
</script>
